// 本地开发
let host = `${process.env.VUE_APP_API_BASE_URL}/wjgl`;
export default {
	host,
	url: `${process.env.VUE_APP_API_BASE_URL}`, // 网址
	publicinfo: {
		// 本地开发
		webhost: `${process.env.VUE_APP_API_BASE_URL}/wjgl`, //注意包含应用程序名称
	},
	service: {
		modifyLoginName: `${host}/api/v1/user/modifyLoginName`, //修改用户名
		exportAllCrossAnalysis: `${host}/api/v1/cross-analyze/exportAllCrossAnalysis`, //导出问卷的全部交叉分析(Excle/word)
		exportingleCrossAnalysis: `${host}/api/v1/cross-analyze/exportingleCrossAnalysis`, //导出单个
		setChartType: `${host}/api/v1/cross-analyze/setChartType`, //设置图表类型
		delete: `${host}/api/v1/cross-analyze/delete`, //删除交叉分析
		queryCrossAnalyzeDetails: `${host}/api/v1/cross-analyze/queryCrossAnalyzeDetails`, //查询已有交叉分析的数据详情
		queryCrossAnalyze: `${host}/api/v1/cross-analyze/queryCrossAnalyze`, //查询已有交叉分析
		exportAllCrossAnalysis: `${host}/api/v1/cross-analyze/exportAllCrossAnalysis`, //导出交叉分析
		addCrossAnalyse: `${host}/api/v1/cross-analyze/addCrossAnalyse`, // 添加交叉分析
		queryQuestionsCount: `${host}/api/v1/sms-email-balance/queryQuestionsCount`, //短信余额
		notifyUrl: `${host}/recharge-record/notifyUrl`, //支付宝充值成功回调页面
		alipay: `${host}/payment/alipay`, //支付宝充值
		queryTradingRecordpage: `${host}/api/v1/red-packet/queryTradingRecordpage`, //查询消费记录
		exportredpacketstatistics: `${host}/api/v1/red-packet/exportredpacketstatistics`, //导出
		updateredpacketprobability: `${host}/api/v1/red-packet/updateredpacketprobability`, //修改红包概率
		queryredpacketstatistics: `${host}/api/v1/red-packet/queryredpacketstatistics`, //查看红包发放情况统计
		cancelredpacket: `${host}/api/v1/red-packet/cancelredpacket`, //取消红包
		queryredpacketlist: `${host}/api/v1/red-packet/queryredpacketlist`, // 查询发布的红包列表
		addredpacket: `${host}/api/v1/red-packet/addredpacket`, //添加红包
		mywallet: `${host}/api/v1/red-packet/mywallet`, //我的钱包
		// 红包
		exportTopicStatistics: `${host}/api/v1/questions-obj/exportTopicStatistics`, //导出ex
		downloadUploadFilesZip: `${host}/api/v1/questions-obj/downloadUploadFilesZip`, //下载上传文件
		downloadFile: `${host}/api/v1/downloadrecord/downloadFile`, //下载文件
		queryDownloadRecord: `${host}/api/v1/downloadrecord/queryDownloadRecord`, //查询我的下载数据
		uploadFilesQuestion: `${host}/api/v1/questions-obj/uploadFilesQuestion`, // 文件上传
		siteQuestion: `${host}/api/v1/questions-obj/siteQuestion`, //城市选择
		matrixInputQuestion: `${host}/api/v1/questions-obj/matrixInputQuestion`, //矩阵填空题分页
		inputQuestion: `${host}/api/v1/questions-obj/inputQuestion`, //填空题分页
		dataStatistics: `${host}/api/v1/questions-obj/dataStatistics`, //新题目统计
		bindUserEmail: `${host}/api/v1/user/bindUserEmail`, //绑定邮箱
		bindPhone: `${host}/api/v1/user/bindPhone`, //绑定微信
		qqLogin: `${host}/api/v1/user/qq/qqLogin`, //qq登录
		wechatLoginCallBack: `${host}/api/v1/user/wechat/wechatLoginCallBack1`, //微信登录回调
		wechatLogin: `${host}/api/v1/user/wechat/wechatLogin`, //微信登录
		examineAnswerSheet: `${host}/api/v1/questions-option-obj/examineAnswerSheet`, //文件详情
		queryonesampledata: `${host}/api/v1/questionnaire-obj-sample/queryonesampledata`, //查看单个样本
		canceldistributionsample: `${host}/api/v1/questionnaire-obj-sample/canceldistributionsample`, //分配取消分配
		addfiletitle: `${host}/api/v1/questionnaire-obj-sample/addfiletitle`, //导入文件数据
		queryquestionnairetitle: `${host}/api/v1/questionnaire-obj-sample/queryquestionnairetitle`, // 已匹配样本列表
		uploadsample: `${host}/api/v1/questionnaire-obj-sample/uploadsample`, //上传样本文件
		emptysampledata: `${host}/api/v1/questionnaire-obj-sample/emptysampledata`, //清空样本数据
		delsampledata: `${host}/api/v1/questionnaire-obj-sample/delsampledata`, //删除样本数据
		querysampledatalistpage: `${host}/api/v1/questionnaire-obj-sample/querysampledatalistpage`, //样本管理
		queryassignpeople: `${host}/api/v1/questionnaire-obj-sample/queryassignpeople`, // 查询指派人员信息
		querysampledatapage: `${host}/api/v1/questionnaire-obj-sample/querysampledatapage`, //查询样本数据列表
		queryquestionnairetitle: `${host}/api/v1/questionnaire-obj-sample/queryquestionnairetitle`, //问卷样本 已经匹配
		SetAnswerPlaza: `${host}/api/v1/questionnaire/setAnswerPlaza`, //问卷广场开关
		queryAnswerPlaza: `${host}/api/v1/questionnaire/queryAnswerPlaza`, //问卷广场查询列表
		querySmsNumber: `${host}/api/v1/user/querySmsNumber`, //短信发送确认
		updateQuestionnaireStyle: `${host}/api/v1/questionnaire-style/updateQuestionnaireStyle`, //外观
		setHeader: `${host}/api/v1/questionnaire-style/setHeader`, //设置页眉
		login: `${host}/api/v1/user/login`, //登录
		sendEmailCode: `${host}/api/v1/user/sendEmailCode`, // 发送邮箱验证码
		sendPhoneCode: `${host}/api/v1/user/sendPhoneCode`, //发送手机验证码
		questionTypeList: `${host}/api/v1/question-type/questionTypeList`, // 查询题型
		phoneLogin: `${host}/api/v1/user/phoneLogin`, // 手机验证登录
		wjinfo: `${host}/api/v1/questionnaire/getonequestionnaire`,
		wjadd: `${host}/api/v1/questionnaire/add`,
		wjedit: `${host}/api/v1/questionnaire/update`,
		questionadd: `${host}/api/v1/questions/add`,

		batchAddMatrixColumn: `${host}/api/v1/questions-option/batchAddMatrixColumn`, //批量添加矩阵列
		batchAddMatrixRow: `${host}/api/v1/questions-option/batchAddMatrixRow`, //批量添加矩阵行
		questionaddbatch: `${host}/api/v1/questions/batchaddquestionsoption`,
		questionupd: `${host}/api/v1/questions/upda`,
		questionupdoption: `${host}/api/v1/questions/updaoption`,
		addoneoption: `${host}/api/v1/questions/addoneoption`, //添加选项
		addoneotheroption: `${host}/api/v1/questions/addoneotheroption`, //添加其他选项
		deloneoption: `${host}/api/v1/questions/deloneoption`,
		questiondel: `${host}/api/v1/questions/delquestions`,
		questionlist: `${host}/api/v1/questions/queryonequestionsoption`,
		mywjlist: `${host}/api/v1/questionnaire/page`,
		queryquestionnairetype: `${host}/api/v1/questionnaire-type/queryquestionnairetype`,
		pageopen: `${host}/api/v1/questionnaire/pageopen`,
		setupoptionifrandom: `${host}/api/v1/questions/setupoptionifrandom`,
		publishwj: `${host}/api/v1/questions-option-obj/updateQuestionnaireState`,
		shareQuestionnaire: `${host}/api/v1/questionnaire/shareQuestionnaire`,
		TopicStatistics: `${host}/api/v1/questions-option-obj/dataStatistics`,
		querydataSurvey: `${host}/api/v1/questionnaire-obj/querydataSurvey`,
		queryQuestionTypes: `${host}/api/v1/questionnaire-type/queryQuestionTypes`,
		queryTestQuestions: `${host}/api/v1/questions/queryTestQuestions`,
		addNewQuestions: `${host}/api/v1/questions/addNewQuestions`,
		exportToCsv: `${host}/api/v1/questions-option-obj/exportToCsv`, //csv下载
		objgradeCountExport: `${host}/api/v1/questionnaire-obj/gradeCountExport`, //成绩统计-导出数据
		addMatrixQuestionsOption: `${host}/api/v1/questions/addMatrixQuestionsOption`,
		userRegister: `${host}/api/v1/user/userRegister`,
		copyQuestionnaire: `${host}/api/v1/questionnaire/copyQuestionnaire`,
		newcopyQuestionnaire: `${host}/api/v1/questionnaire/newcopyQuestionnaire`,
		preview: `${host}/api/v1/questions-option-obj/preview`,
		quoteQuestionnaire: `${host}/api/v1/questionnaire/quoteQuestionnaire`,
		importQuestionnaire: `${host}/api/v1/questionnaire/importQuestionnaire`,
		getAllUserBaseInfo: `${host}/api/v1/user/getAllUserBaseInfo`,
		setStatisticalStyle: `${host}/api/v1/questions/setStatisticalStyle`,
		exportQuestjions: `${host}/api/v1/questions-option-obj/exportQuestionnaire`, //我的问卷导出项目
		emptyquestionnaire: `${host}/api/v1/questionnaire-obj/emptyquestionnaire`, //我的问卷清除数据
		falsedelete: `${host}/api/v1/questionnaire/falsedelete`, //我的问卷删除项目
		exportSav: `${host}/api/v1/questions-option-obj/exportSav`, //数据页面导出SPSS
		queryProvince: `${host}/api/v1/city-address/queryProvince`, //查询省
		queryLinkage: `${host}/api/v1/city-address/queryLinkage`, // 查询市
		upToken: `${host}/api/v1/file/up-token`, // 获取上传token
		addoneoptionimg: `${host}/api/v1/questions/addoneoptionimg`, //上传图片返回给后台图片名称
		updaoptionimg: `${host}/api/v1/questions/updaoptionimg`, // 上传图片是修改图片
		downPageQuestion: `${host}/api/v1/questions-option-obj/downPageQuestion`, //分页时下一页接口\
		upPageQuestion: `${host}/api/v1/questions-option-obj/upPageQuestion`, //分页时上一页接口
		answer: `${host}/api/v1/questions-option-obj/answer`, //预览页面答题接口
		startSorting: `${host}/api/v1/questions-option-obj/startSorting`, //预览页开始排序
		changePassword: `${host}/api/v1/user/change_password`, // 修改登录密码
		modifyPassword: `${host}/api/v1/user/modifyPassword`, //修改用户密码
		setuppassword: `${host}/api/v1/user/setuppassword`, // 设置用户密码
		setupwxlimit: `${host}/api/v1/questionnaire/setupwxlimit`, // 每个微信答题次数限制开关
		setupclimit: `${host}/api/v1/questionnaire/setupclimit`, // 每台电脑或手机答题次数限制开关
		setupiplimit: `${host}/api/v1/questionnaire/setupiplimit`, // 每个IP答题次数限制开关
		setupstartuppassword: `${host}/api/v1/questionnaire/setupstartuppassword`, //启动访问密码开关
		setuponlyemail: `${host}/api/v1/questionnaire/setuponlyemail`, // 只有邮件邀请的受访者可回答
		setupsetstartendtime: `${host}/api/v1/questionnaire/setupsetstartendtime`, // 设置开始/结束时间开关
		setBreakpointAnswer: `${host}/api/v1/questionnaire/setBreakpointAnswer`, // 设置断点续答
		setNewMsgtoWX: `${host}/api/v1/questionnaire/setNewMsgtoWX`, //  设置有新消息微信提醒
		setNewMsgtoEmail: `${host}/api/v1/questionnaire/setNewMsgtoEmail`, //  设置有新消息邮箱提醒
		setuponlywx: `${host}/api/v1/questionnaire/setuponlywx`, //  只能通过微信回答开关
		setuprecordwxuser: `${host}/api/v1/questionnaire/setuprecordwxuser`, //  只记录微信用户个人信息开关
		setProhibitWXShare: `${host}/api/v1/questionnaire/setProhibitWXShare`, //  禁止微信右上角分享
		setupSetAnswerLimit: `${host}/api/v1/questionnaire/setupSetAnswerLimit`, //  设定答题数据上限开关
		setIfPageAnswerTime: `${host}/api/v1/questionnaire/setIfPageAnswerTime`, //  设置页面填写时间开关
		setIfAllowStatistics: `${host}/api/v1/questionnaire/setIfAllowStatistics`, //  是否允许受访人查看统计
		setIfDisplayShare: `${host}/api/v1/questionnaire/setIfDisplayShare`, //  是否显示分享按钮
		setIfCustomJump: `${host}/api/v1/questionnaire/setIfCustomJump`, //  答题完成后自定义跳转开关
		setShareSeoIndex: `${host}/api/v1/questionnaire/setShareSeoIndex`, //  允许搜索引擎检索项目内容
		setModifyIsStaging: `${host}/api/v1/tbPaperUnderwayController/modifyIsStaging`, //  是否开启问卷暂存功能
		modifyRandomJson: `${host}/api/v1/tbPaperUnderwayController/modifyRandomJson`, //  设置问卷随机功能
		setModifyIsEntry: `${host}/api/v1/tbPaperUnderwayController/modifyIsEntry`, //  设置问卷的是否开启录入功能
		setHideLogo: `${host}/api/v1/questionnaire/setHideLogo`, // 隐藏“神采”logo
		updawxlimitnumber: `${host}/api/v1/questionnaire/updawxlimitnumber`, // 每个微信答题次数数量
		pclimitnumber: `${host}/api/v1/questionnaire/pclimitnumber`, // 每台电脑或手机答题次数限制
		updaipLimitNumber: `${host}/api/v1/questionnaire/updaipLimitNumber`, // 每个IP答题次数限制
		startuppassword: `${host}/api/v1/questionnaire/updastartuppasswordnumber`, // 启动访问密码
		answerlimit: `${host}/api/v1/questionnaire/updasetanswerlimitnumber`, // 设定答题数据上限
		answerTime: `${host}/api/v1/questionnaire/setPageAnswerTime`, // 设定页面填写时间开关
		downLoadQrCode: `${host}/api/v1/questionnaire/downLoadQrCode`, // 发布页面下载二维码接口
		setWXSharePicture: `${host}/api/v1/questionnaire/setWXSharePicture`, // 设置微信分享图片
		delWXSharePicture: `${host}/api/v1/questionnaire/delWXSharePicture`, // 删除微信分享图片
		setWXShareTitle: `${host}/api/v1/questionnaire/setWXShareTitle`, // 设置微信分享标题
		setWXShareContent: `${host}/api/v1/questionnaire/setWXShareContent`, // 设置微信分享内容
		queryContacts: `${host}/api/v1/contacts/queryGroupContacts`, // 查询所有联系人
		searchContacts: `${host}/api/v1/contacts/searchContacts`, // 搜索联系人
		auditSucceed: `${host}/api/v1/questions-sms/auditSucceed`, // 发送
		addquestionssms: `${host}/api/v1/questions-sms/addquestionssms`, // 下一步
		setupifmustanswer: `${host}/api/v1/questions/setupifmustanswer`, // 设置题目必答
		setQuestionsTypeId: `${host}/api/v1/questions/setQuestionsTypeId`, //重新设置问题类型
		setupsingleoption: `${host}/api/v1/questions/setupsingleoption`, // 设置单选
		setInputBoxSize: `${host}/api/v1/questions/setInputBoxSize`, // 设置输入框大小
		setIfLengthLimit: `${host}/api/v1/questions/setIfLengthLimit`, // 设置输入框内容
		setupleast: `${host}/api/v1/questions/setupleast`, // 设置最少输入
		setupmost: `${host}/api/v1/questions/setupmost`, // 设置最多输入
		setupoptionifrandom: `${host}/api/v1/questions/setupoptionifrandom`, // 设置选项随机排列
		setInGroupRandom: `${host}/api/v1/questions/setInGroupRandom`, // 设置组内随机排列
		setBetweenGroupRandom: `${host}/api/v1/questions/setBetweenGroupRandom`, // 设置组间随机排列
		setupmanyoption: `${host}/api/v1/questions/setupmanyoption`, // 设置多选
		BoxAppearance: `${host}/api/v1/questions/setInputBoxAppearance`, // 是否可以手动修正
		setupCitySelection: `${host}/api/v1/questions/setupCitySelection`, // 城市选择 , 详细程度
		MatrixLineRandom: `${host}/api/v1/questions/setupMatrixLineRandom`, // 行随机
		MatrixRankRandom: `${host}/api/v1/questions/setupMatrixRankRandom`, // 列随机
		setupleast: `${host}/api/v1/questions/setupleast`, // 最少填写多少字
		setupmost: `${host}/api/v1/questions/setupmost`, // 最多填写多少字
		fixedlastoption: `${host}/api/v1/questions/setupiffixedlastoption`, // 固定最后一个选项
		questionInputBox: `${host}/api/v1/questions/setInputBoxSetting`, // 设置单行或者多行输入框
		choiceLayout: `${host}/api/v1/questions/setupoptionchoiceLayout`, // 设置几列
		EmailContacts: `${host}/api/v1/questions-email/queryQuestionsEmailContacts`, // 查询邮件联系人列表
		changeOption: `${host}/api/v1/questions-option/changeOption`, // 横向填空修改
		selectOption: `${host}/api/v1/questions-option/selectOption`, // 横向填空设置选项
		setupUploadQuantity: `${host}/api/v1/questions/setupUploadQuantity`, // 文件上传最大数量
		LineRank: `${host}/api/v1/questions/setupLineRankExchange`, // 矩阵设置行列交换
		addQuestionsEmail: `${host}/api/v1/questions-email/addQuestionsEmail`, // 发送邮件下一步接口
		selectQuestionnaire: `${host}/api/v1/questionnaire-style/selectStyleByQuestionnaire`, // 外观内容接口
		selectAppearance: `${host}/api/v1/questionnaire-appearance/selectAppearance`, // 外观样式
		setsSubjectColor: `${host}/api/v1/questionnaire-appearance/setsSubjectColor`, // 设置问卷主题色
		queryScoreImg: `${host}/api/v1/questions/queryScoreImg`, // 设置不同的评分图片
		questionsSms: `${host}/api/v1/questions-sms/quertAllQuestionsSms`, // 查看已分享短信
		save: `${host}/api/v1/contacts/save`, // 新增联系人
		deleteCContacts: `${host}/api/v1/contacts/deleteCContacts`, // 删除联系人
		importContacts: `${host}/api/v1/contacts/importContacts`, // 导入
		addContactsType: `${host}/api/v1/contacts-type/addContactsType`, // 添加群组或者是标签
		deleteContactsType: `${host}/api/v1/contacts-type/deleteContactsType`, // 删除群组或者是标签
		updateContactsType: `${host}/api/v1/contacts-type/updateContactsType`, // 修改群组或者是标签
		addAnswerPhone: `${host}/api/v1/answer-phone/addAnswerPhone`, // 添加手机号答题
		queryAllEmail: `${host}/api/v1/questions-email/queryAllQuestionsEmail`, // 查询已发送邮件
		QuestionsSmsContacts: `${host}/api/v1/questions-sms/queryQuestionsSmsContacts`, //  查询问卷短信下面的联系人
		updasetstartendtime: `${host}/api/v1/questionnaire/updasetstartendtime`, //  设定开始/结束时间
		setCollectMethods: `${host}/api/v1/questionnaire/setCollectMethods`, //  设置收集方式
		setAccreditAteMethods: `${host}/api/v1/questionnaire/setAccreditAteMethods`, //  设置授权方式
		setCustomJump: `${host}/api/v1/questionnaire/setCustomJump`, //  答题完成后自定义跳转
		setSkip: `${host}/api/v1/questionnaire/setSkip`, //  答题完成后设置跳转设置
		TypeTag: `${host}/api/v1/contacts-type/queryContactsTypeTag`, //  查询用户下所有标签
		queryContactsType: `${host}/api/v1/contacts-type/queryContactsType`, //  查询用户下所有群组,标签
		queryContactsLoad: `${host}/api/v1/contacts/queryContacts`, //  查询联系人
		querydataSurvey: `${host}/api/v1/questionnaire-obj/querydataSurvey`, //  查询数据详情列表
		queryQuestions: `${host}/api/v1/questionnaire-obj/queryQuestionsList `, //  查询数据详情列表
		queryQuestionsData: `${host}/api/v1/questionnaire-obj/queryQuestionsData`, //  查询数据详情列表数据
		exportQuestionsData: `${host}/api/v1/questionnaire-obj/exportQuestionsData`, //  导出数据详情列表数据
		ObjType: `${host}/api/v1/questionnaire-obj/queryQuestionnaireObjType`, //  按系统环境查询各地区数据
		aireObj: `${host}/api/v1/questionnaire-obj/queryRegionQuestionnaireObj`, //  按省份地区查询各地区数据
		queryAllQuota: `${host}/api/v1/questionnaire-quota/queryAllQuota`, //  获取配额页有无设置配额
		ssoLogin: `${host}/api/v1/sso/login`, //  登录空页面
		queryQuotaQuestions: `${host}/api/v1/questionnaire-quota/queryQuotaQuestions`, //  查询可配额的题目
		saveQuota: `${host}/api/v1/questionnaire-quota/saveQuota`, //  添加配额
		delQuota: `${host}/api/v1/questionnaire-quota/delQuota`, //  删除配额
		queryQuota: `${host}/api/v1/questionnaire-quota/queryQuota`, //  查询配额信息
		selectdownAllQuestions: `${host}/api/v1/questions/selectdownAllQuestions`, //  跳转逻辑弹框页面查询指定题目后面的所有题目
		JumpLogic: `${host}/api/v1/jump-logic/queryQuestionnJumpLogic`, //  查询问卷下的跳转逻辑
		queryJumpLogic: `${host}/api/v1/jump-logic/queryJumpLogic`, //  查询指定题目的所有跳转逻辑
		queryDefault: `${host}/api/v1/questions-option/queryDefaultOption`, //  查询指定题目的所有选项
		addJumpLogic: `${host}/api/v1/jump-logic/addJumpLogic`, //  添加跳转逻辑
		selectupAllQuestions: `${host}/api/v1/questions/selectupAllQuestions`, //  查询显示逻辑指定题目前面的所有题目
		queryCondition: `${host}/api/v1/display-logic/queryCondition`, //  查询显示逻辑选择条件
		defaultOption: `${host}/api/v1/questions-option/selectDefaultOption`, //  查询显示逻辑被选中的选项
		displayLogic: `${host}/api/v1/display-logic/queryDisplayLogic`, //  查询显示逻辑查询指定题目的显示逻辑
		addDisplayLogic: `${host}/api/v1/display-logic/addDisplayLogic`, //  查询显示逻辑添加显示逻辑
		selectAllPage: `${host}/api/v1/questions/selectAllQuestions`, //  逻辑编辑页面中查询问卷下所有题目
		setupjumplogic: `${host}/api/v1/questions/setupjumplogic`, //  逻辑编辑页面中设置单题跳转逻辑
		depJumpLogic: `${host}/api/v1/jump-logic/depJumpLogic`, //  逻辑编辑页面中设删除单挑逻辑跳转
		delDisplayLogic: `${host}/api/v1/display-logic/delDisplayLogic`, //  逻辑编辑页面中设删除单挑逻辑显示
		queryDsiplatLog: `${host}/api/v1/display-logic/queryQuestionnaireDisplayLogic`, //  逻辑编辑页面中查询显示逻辑
		queryJmupLog: `${host}/api/v1/jump-logic/queryQuestionnJumpLogic`, //  逻辑编辑页面中查询跳转逻辑
		setupdisplaylogic: `${host}/api/v1/questions/setupdisplaylogic`, //  逻辑编辑页面中添加显示逻辑
		queryGroup: `${host}/api/v1/questions-option-group/queryGroup`, // 查询选项分组
		queryOptionGroup: `${host}/api/v1/questions-option-group/queryOptionGroup`, // 查询可分组的选项
		saveOptionGroup: `${host}/api/v1/questions-option-group/saveOptionGroup`, // 保存分组信息
		modifyUser: `${host}/api/v1/user/modifyUserHeadImg`, // 保存修改后的头像
		modifyAll: `${host}/api/v1/user/modifyAllUserInfo`, // 保存地址修改
		modifyUserInfo: `${host}/api/v1/user/modifyUserInfo`, // 修改用户基础信息
		ifOpenShortTime: `${host}/api/v1/questions/ifOpenShortTime`, // 设置分页最短停留时间
		ifOpenLongTime: `${host}/api/v1/questions/ifOpenLongTime`, // 设置分页最长停留时间
		setOpenLongTime: `${host}/api/v1/questions/setOpenLongTime`, // 设置分页最长停留时间秒
		setOpenShortTime: `${host}/api/v1/questions/setOpenShortTime`, // 设置分页最短停留时间秒
		applyToAl: `${host}/api/v1/questions/applyToAl`, // 应用于所有分页
		setupButton: `${host}/api/v1/questions/setupButton`, // 设置上一页按钮文字
		setBelowButton: `${host}/api/v1/questions/setBelowButton`, // 设置下一页按钮文字
		setShowButton: `${host}/api/v1/questions/setShowButton`, // 是否显示上一页按钮文字
		updastate: `${host}/api/v1/questionnaire/updastate`, // 修改我的问卷弹窗提示
		pagefalse: `${host}/api/v1/questionnaire/pagefalse`, // 查询回收站项目
		recovery: `${host}/api/v1/questionnaire/recovery`, // 从回收站恢复项目
		truedelete: `${host}/api/v1/questionnaire/delete`, // 从回收站删除项目
		setIfFillEmpty: `${host}/api/v1/questions-option/setIfFillEmpty`, // 选项后边添加填空框
		setOptionIfLengthLimit: `${host}/api/v1/questions-option/setIfLengthLimit`, // 选项后边内容限制
		openMinLength: `${host}/api/v1/questions-option/openMinLength`, // 选项后边是否开启长度限制
		setNotAnswer: `${host}/api/v1/questions-option/setNotAnswer`, // 选项后边该空不可填
		queryRelatableQuestion: `${host}/api/v1/relation-logic/queryRelatableQuestion`, // 查询可关联的题目
		updateRelationLogic: `${host}/api/v1/relation-logic/updateRelationLogic`, // 添加关联
		queryRelationLogic: `${host}/api/v1/relation-logic/queryRelationLogic`, // 添加关联
		addCross: `${host}/api/v1/questions-option-obj/addCross`, // 查询因变量自变量选项
		queryCrossAnalysis: `${host}/api/v1/questions-option-obj/queryCrossAnalysis`, // 查询问卷的交叉分析
		crossAnalysis: `${host}/api/v1/questions-option-obj/crossAnalysis`, // 添加交叉分析
		caslogin: `${host}/api/v1/sso/caslogin`, // cas单点登录(最初的接口)
		futianlogin: `${host}/api/v1/sso/futianlogin`, // cas单点登录(接口更新了)
		setContactsType: `${host}/api/v1/contacts/setContactsType`, // 设置联系人 群组/标签
		queryContactsGroupTags: `${host}/api/v1/contacts/queryContactsGroupTags`, // 查询联系人群组(标签)数量
		exportContact: `${host}/api/v1/contacts/exportContact`, // 导出联系人
		purchasesms: `${host}/api/v1/sms-email-balance/purchasesms`, // 购买短信条数
		purchaemail: `${host}/api/v1/sms-email-balance/purchaemail`, // 购买邮件条数
		queryQuestionsSmsSendDetails: `${host}/api/v1/questions-sms/queryQuestionsSmsSendDetails`, // 查询该问卷短信发送详情
		queryQuestionsEmailSendDetails: `${host}/api/v1/questions-email/queryQuestionsEmailSendDetails`, // 查询该问卷邮件发送详情
		sendEmail: `${host}/api/v1/questions-email/sendEmail`, // 发送邮件
		scoreAnnotation: `${host}/api/v1/questions/scoreAnnotation`, // 设置评分左中右文字
		setScoreImg: `${host}/api/v1/questions/setScoreImg`, // 设置评分图片
		sendBindEmail: `${host}/api/v1/user/sendBindEmail`, // 绑定邮箱
		bindUserPhone: `${host}/api/v1/user/bindUserPhone`, // 绑定手机号

		examPageListCount: `${host}/exam/tbExamProject/pageListCount`, // 考试项目表-查询考试项目表分页加统计
		examUpdateExamUnderway: `${host}/exam/tbExamProject/updateExamUnderway`, // 考试项目表-清空参加考试数据逻辑删除
		examDeleteExamUnderway: `${host}/exam/tbExamProject/deleteExamUnderway`, // 考试项目表-清空参加考试数据直接删除

		examimportWord: `${host}/exam/tbExamProject/importWord`, // 考试项目表-导入word
		examimportExcel: `${host}/exam/tbExamProject/importExcel`, // 考试项目表-导入Excel
		examProjectAdd: `${host}/exam/tbExamProject/addReturnId`, // 考试项目表(添加返回id)
		examPaperDelete: `${host}/exam/tbExamProject/delete`, // 考试项目表(删除)
		examPaperisDel: `${host}/exam/tbExamProject/isDel`, // 考试项目表(逻辑删除)
		examPaperAdd: `${host}/exam/tbExamPaper/add`, // 考试试题提交
		examPaperQueryById: `${host}/exam/tbExamPaper/queryById`, //  考试设计-试题-问卷表-通过id查询
		examPaperpreview: `${host}/exam/tbExamPaper/preview`, //  考试项目表-进行中-预览问卷
		examAppearanceAdd: `${host}/system/appearance/add`, //  考试-外观-新增保存
		examAppearanceFindById: `${host}/system/appearance/findById`, //  考试-外观-添加
		examfindOneBySurveyId: `${host}/system/appearance/findOneBySurveyId`, //  考试-外观-通过id查询
		examedit: `${host}/system/appearance/edit`, //  考试-外观修改



		examProjectBasicSetup: `${host}/exam/tbExamProject/basicSetup`, // 考试项目-基本设置
		examProjectSubmitShow: `${host}/exam/tbExamProject/submitShow`, // 考试项目-提交后显示设置
		examProjectWxInstall: `${host}/exam/tbExamProject/wxInstall`, // 考试项目-微信设置
		examProjectAnswerSet: `${host}/exam/tbExamProject/answerSet`, // 考试项目-答题限制
		examProjectTitleInstall: `${host}/exam/tbExamProject/titleInstall`, // 考试项目-题目设置
		examProjectAnswerPageShowInstall: `${host}/exam/tbExamProject/answerPageShowInstall`, // 考试项目-答题页显示设置
		examProjectShareInstall: `${host}/exam/tbExamProject/shareInstall`, // 考试项目-分享设置
		examProjectStopCheatInstall: `${host}/exam/tbExamProject/stopCheatInstall`, // 考试项目-防作弊设置其他设置
		examProjectStopCheatRandom: `${host}/exam/tbExamProject/stopCheatRandom`, // 考试项目表-防作弊随机抽题保存
		examstopCheatfindBySurveyId: `${host}/exam/stopCheat/findBySurveyId`, // 考试项目表-防作弊随机抽题回显
		examProjectEditState: `${host}/exam/tbExamProject/editProjectState`, // 考试项目表-修改项目状态(发布)

		examGradeCount: `${host}/system/ranking/gradeCount`, // 考试项目表-成绩统计
		examGadeCountExport: `${host}/system/ranking/gradeCountExport`, // 考试项目表-成绩统计-导出数据
		examFractionalSet: `${host}/system/ranking/fractionalSet`, // 考试项目表-成绩统计-获取分数图表信息
		examFindFractionalSet: `${host}/exam/tbExamProject/findFractionalSet`, // 考试项目表-成绩统计-获取分数段
		examUpdateFractionalSet: `${host}/exam/tbExamProject/updateFractionalSet`, // 考试项目表-成绩统计-修改分数段
		examFindTeacherScore: `${host}/exam/underway/findTeacherScore`, // 考试项目表-查询评分老师问卷
		examUserList: `${host}/exam/underway/userList`, // 考试项目表-查询评分姓名集合
		examProjectCopy: `${host}/exam/tbExamProject/projectCopy`, // 考试项目表-项目复制
		examAddTeacherScore: `${host}/exam/underway/addTeacherScore`, // 考试项目表-保存老师评分后问卷信息
		examQuestionAccuracy: `${host}/system/ranking/questionAccuracy`, // 成绩统计-题目正确率
		examFindQuestionAnswerInfo: `${host}/system/ranking/findQuestionAnswerInfo`, // 成绩统计-查询填空题、简答题详情接口
		examTimeSourceAnalyse: `${host}/system/ranking/timeSourceAnalyse`, // 答案来源分析-时间段分析
		examTerritorySourceAnalyse: `${host}/system/ranking/territorySourceAnalyse`, // 答案来源分析-时间段分析
		examWxLogoInstall: `${host}/exam/tbExamProject/wxLogoInstall`, // 考试项目表-logo设置
		examRanking: `${host}/system/ranking/ranking`, // 考试项目-排行榜



		examProjectQueryById: `${host}/exam/tbExamProject/queryById`, // 考试项目表-通过id 获取列表

		examUnderwayAddAnswer: `${host}/exam/underway/addAnswer`, // 考试项目-进行中-提交考试
		examUnderwayClickAnswer: `${host}/exam/underway/clickAnswer`, // 考试项目-进行中-获取考试权限以及试题结构
		// 

		WXgetOpenId: `${host}/api/v1/user/getOpenId`, // 获得openId
		WXuserByWeChatLogin: `${host}/api/v1/user/userByWeChatLogin`, // 用户通过微信登录
		examRear: `${host}/rear`, // 考试-项目随机id链接(用于链接分享)

		examexportRankingExcel: `${host}/system/ranking/exportRankingExcel`, // 导出排行榜
		examAppmanByLogInUserId: `${host}/exam/tbExamProject/appmanByLogInUserId`, // 考试项目表-根据登录用户查回收站
		examRestoreAppman: `${host}/exam/tbExamProject/restoreAppman`, // 考试项目表-根据登录用户查回收站
		examDelAppman: `${host}/exam/tbExamProject/delAppman`, // 考试项目表-删除回收站
		examDelBlank: `${host}/exam/tbExamProject/delBlank`, // 考试项目表-彻底删除（与会回收站作用相同，但是不需要密码验证）
		
		// 我的问卷
		addQuestionnaire: `${host}/api/v1/questionnaire/addQuestionnaire`,
		addTemp: `${host}/exam/tbExamPaper/addTemp`,
		queryPaperConfig: `${host}/api/v1/tbPaperUnderwayController/queryPaperConfig`, // 获取问卷试题信息
		saveAnswer: `${host}/api/v1/tbPaperUnderwayController/saveAnswer`, // 提交答案
		verifyQuota: `${host}/api/v1/questionnaireNewQuota/verifyQuota`, // 更新配额 （提交问卷时调用）

		// 后台管理系统
		// 问卷模板
		tempPaperList: `${host}/api/v1/temp-paper/list`, // 查询列表
		tempPaperDel: `${host}/api/v1/temp-paper/del`, // 删除
		tempPaperSaveAndUpdate: `${host}/api/v1/temp-paper/saveAndUpdate`, //修改或者新增
		tempPaperInfo: `${host}/api/v1/temp-paper/infol`, //详情
		// 问卷类型
		addQuestionTypes: `${host}/api/v1/questionnaire-type/addQuestionTypes`, //添加题库类型
		tempPaperQuest: `${host}/api/v1/questionnaire-type/queryquestionnairetype`, //查询问卷类型分类
		delQuestionTypes: `${host}/api/v1/questionnaire-type/delQuestionTypes`, //删除题库类型
		questionnaireTypeUpdate: `${host}/api/v1/questionnaire-type/update`, //删除题库类型
		questionnaireTypeSort: `${host}/api/v1/questionnaire-type/sort`, //更新问卷类型排序+
		// 用户管理
		// 管理员查询用户
		selectUsers: `${host}/api/v1/user/app/selectUsers`, //管理员查询用户
		updateUser: `${host}/api/v1/user/app/updateUser`, //管理员修改用户信息
		// 电访配额
		queryQuess: `${host}/api/v1/questionnaireNewQuota/queryQuess`, //查询问卷题干
		saveQuota: `${host}/api/v1/questionnaireNewQuota/saveQuota`, //添加配额
		queryQuota: `${host}/api/v1/questionnaireNewQuota/queryQuota`, //查询配额信息
		delNewQuota: `${host}/api/v1/questionnaireNewQuota/delQuota`, //删除配额
		// 样本配置
		sampleImport: `${host}/api/v1/questionsfieldmapping/sampleImport`, // 样本导入
		uploadFiles: `${host}/api/v1/questionsfieldmapping/uploadFiles`, //  上传文件
		getFieldName: `${host}/api/v1/questionsfieldmapping/getFieldName`, // 获取源字段和目标字段
		// 设置左中右
		queryAllFieldName: `${host}/api/v1/questionsfieldmapping/queryAllFieldName`, // 查询本问卷全部字段
		queryFieldConfig: `${host}/api/v1/questionsfieldmappingconfig/queryFieldConfig`, //查询问卷左中右显示字段
		modifyFieldConfig: `${host}/api/v1/questionsfieldmappingconfig/modifyFieldConfig`, // 修改问卷左中右显示字段
		saveFieldConfig: `${host}/api/v1/questionsfieldmappingconfig/saveFieldConfig`, //设置问卷左中右显示字段

		allintervieweruserdistribution: `${host}/api/v1/interviewer-user/allintervieweruserdistribution`, //分配全部访员
		allinterviewerusercanceldistribution: `${host}/api/v1/interviewer-user/allinterviewerusercanceldistribution`, //取消分配全部访员
		// 样本配置
		queryAllSample: `${host}/api/v1/questionssample/queryAllSample`, //查询本问卷全部样本
		removeAllSample: `${host}/api/v1/questionssample/removeAllSample`, //删除本问卷全部样本
		removeOneSample: `${host}/api/v1/questionssample/removeOneSample`, // 根据文档id删除样本
		removeInitSample: `${host}/api/v1/questionssample/removeInitSample`, // 删除初始样本
		removeSampleBySampleId: `${host}/api/v1/questionssample/removeSampleBySampleId`, //删除选中样本
		initSample: `${host}/api/v1/questionssample/initSample`, //根据文档id初始化样本
		distinctSample: `${host}/api/v1/questionssample/distinctSample`, // 样本去重

		queryOneSample: `${host}/api/v1/questionssample/queryOneSample`, //根据文档id查看样本详情
		modifyOneSample: `${host}/api/v1/questionssample/modifyOneSample`, //根据文档id修改样本

		// 挂机状态
		// 总
		addInterviewstate: `${host}/api/v1/paperinterviewstate/addInterviewstate`, //添加状态
		modifyInterviewstate: `${host}/api/v1/paperinterviewstate/modifyInterviewstate`, //修改状态
		removeInterviewstate: `${host}/api/v1/paperinterviewstate/removeInterviewstate`, //删除状态
		queryInterviewstate: `${host}/api/v1/paperinterviewstate/queryInterviewstate`, //查询状态
		// 单
		oneAddInterviewstate: `${host}/api/v1/rpaperinterviewstate/addInterviewstate`, //查询状态
		oneModifyInterviewstate: `${host}/api/v1/rpaperinterviewstate/modifyInterviewstate`, //修改状态
		oneRemoveInterviewstate: `${host}/api/v1/rpaperinterviewstate/removeInterviewstate`, //删除状态
		oneQueryInterviewstate: `${host}/api/v1/rpaperinterviewstate/queryInterviewstate`, //查询已分配列表
		oneQueryNoInterviewstate: `${host}/api/v1/rpaperinterviewstate/queryNoInterviewstate`, //查询未分配列表
		addAllInterviewstate: `${host}/api/v1/rpaperinterviewstate/addAllInterviewstate`, //添加全部状态
		removeAllInterviewstate: `${host}/api/v1/rpaperinterviewstate/removeAllInterviewstate`, //删除全部状态

		// 分配访员
		allintervieweruserdistribution: `${host}/api/v1/interviewer-user/allintervieweruserdistribution`, //分配全部访员
		allinterviewerusercanceldistribution: `${host}/api/v1/interviewer-user/allinterviewerusercanceldistribution`, //取消分配全部访员
		recallAllotSample: `${host}/api/v1/tbPaperUnderwayController/recallAllotSample`, //取消指派样本
		allotSample: `${host}/api/v1/tbPaperUnderwayController/allotSample`, //指派样本
		queryAllotSampleList: `${host}/api/v1/tbPaperUnderwayController/queryAllotSampleList`, //已被指派样本列表
		queryWantToAllotSampleList: `${host}/api/v1/tbPaperUnderwayController/queryWantToAllotSampleList`, //选择被指派样本列表
		queryInterviewerSamleCount: `${host}/api/v1/tbPaperUnderwayController/queryInterviewerSamleCount`, //查询访员名字以及访员分配样本个数
		querySampleDetails: `${host}/api/v1/questionssample/querySampleDetails`, //查询样本详细信息
		// 设置问卷信息
		modifyControllerProperty: `${host}/api/v1/questionnaire/modifyControllerProperty`, //设置访问端的部分控制属性
		queryControllerProperty: `${host}/api/v1/questionnaire/queryControllerProperty`, //查询访问端的部分控制属性
		// 回收样本
		queryUserLaterSampleSum: `${host}/api/v1/questionssample/queryUserLaterSampleSum`, //询访员和名字和稍后样本个数
		queryUserLaterSample: `${host}/api/v1/questionssample/queryUserLaterSample`, //查询访员的稍后样本
		resetUserLaterSample: `${host}/api/v1/questionssample/resetUserLaterSample`, //初始化选中的稍后样本
		resetLaterSampleByIdList: `${host}/api/v1/tbPaperUnderwayController/resetLaterSampleByIdList`, //初始化全部的稍后样本

		// 约访记录
		queryUserAppointmentSampleSum: `${host}/api/v1/questionssample/queryUserAppointmentSampleSum`, //查询访员和名字和约访样本个数
		queryUserAppointmentSample: `${host}/api/v1/questionssample/queryUserAppointmentSample`, //查询访员的约访样本
		transferUserAppointmentSample: `${host}/api/v1/questionssample/transferUserAppointmentSample`, //转让访员的约访样本
		queryMongoSample: `${host}/api/v1/questionssample/queryMongoSample`, //根据mongo的id查询样本详情

		// 服务器配置与坐席绑定
		// 服务器
		serverList: `${host}/api/v1/dialsys/server/list`, //服务器配置列表
		serverUpdate: `${host}/api/v1/dialsys/server/update`, //新增服务器
		serverDel: `${host}/api/v1/dialsys/server/del`, //删除详情
		// 坐席绑定
		bindList: `${host}/api/v1/dialsys/bind/list`, //坐席列表
		bindDel: `${host}/api/v1/dialsys/bind/del`, //删除详情
		bindUpdate: `${host}/api/v1/dialsys/bind/update`, //绑定服务器

		// 样本审核
		queryFinishSample: `${host}/api/v1/questionssample/queryFinishSample`, // 查询全部的完成样本
		setAuditPageShowField: `${host}/api/v1/questionssample/setAuditPageShowField`, // 设置审核页面显示字段
		queryAuditPageShowField: `${host}/api/v1/questionssample/queryAuditPageShowField`, // 查询审核页面显示字段
		aduitsample: `${host}/api/v1/questionssample/aduitsample`, // 对样本进行审核
		queryAduitsampleHistory: `${host}/api/v1/questionssample/queryAduitsampleHistory`, // 查询当前项目样本的审核历史
		resetAduitsampleHistory: `${host}/api/v1/questionssample/resetAduitsampleHistory`, // 对审核历史重新审核
		queryFinishSampleById: `${host}/api/v1/questionssample/queryFinishSampleById`, // 根据id查询样本
		queryFinishSampleTjNumber: `${host}/api/v1/questionssample/queryFinishSampleTjNumber`, // 查询完成样本的总个数，待审核，完成个数 审核失败个数

		// 面访
		getSample: `${host}/sample/filed/getSample`, // 查询字段
		saveOrUpdate: `${host}/sample/filed/saveOrUpdate`, // 保存字段
		// 考试题库
		examBankList: `${host}/api/v1/exam/ques/bank/list`, // 题库列表 0自建题库1系统题库
		examBankSave: `${host}/api/v1/exam/ques/bank/save`, // 保存题库
		examBankUpdate: `${host}/api/v1/exam/ques/bank/update`, // 修改题库
		examBankBankType: `${host}/api/v1/exam/ques/bank/bankType`, // 题库类型
		examBankDel: `${host}/api/v1/exam/ques/bank/del`, // 删除题库
		examBankDetail: `${host}/api/v1/exam/ques/bank/bankDetail`, // 题库详情
		examBankAddCollect: `${host}/api/v1/exam/ques/bank/addCollect`, // 题库收藏
		examBankCollectBank: `${host}/api/v1/exam/ques/bank/getCollectBank`, // 我的收藏列表
		examBankCancelBank: `${host}/api/v1/exam/ques/bank/cancelBank`, // 取消收藏
		examBankAddQuess: `${host}/api/v1/exam/ques/bank/addQuess`, // 添加题干或者修改题干(题库添加试题)
		examBankGetQuess: `${host}/api/v1/exam/ques/bank/getQuess`, // 题库试题详情(题库)
		examBankQuesDetail: `${host}/api/v1/exam/ques/bank/quesDetail`, // 预览题库中所有试题(题库)
		examBankQuesList: `${host}/api/v1/exam/ques/bank/quesList`, // 试题列表(题库)
		examBankDelQues: `${host}/api/v1/exam/ques/bank/delQues`, // 删除试题(我的试题)
		examBankRecycleBinDel: `${host}/api/v1/exam/ques/bank/recycleBinDel`, // 从题库中取消该试题
		examBankRecycleBinCancel: `${host}/api/v1/exam/ques/bank/recycleBinCancel`, // 从题库中取消该试题(不论结果与否 都会返回成功)
		examBankRecycleBinRenew: `${host}/api/v1/exam/ques/bank/recycleBinRenew`, // 回收站恢复
		examBankInferenceList: `${host}/api/v1/exam/ques/bank/inferenceList`, // 反推列表
		examBankInference: `${host}/api/v1/exam/ques/bank/inference`, // 批量反推
		examBankAddDifficultyConf: `${host}/api/v1/exam/ques/bank/addDifficultyConf`, // 新增或者修改配置
		examBankGetDifficultyConf: `${host}/api/v1/exam/ques/bank/getDifficultyConf`, // 获取阈值参数列表
		examBankUpdateQues: `${host}/api/v1/exam/ques/bank/updateQues`, // 修改试题(试题列表)
		examAddQuesToExam: `${host}/api/v1/exam/ques/bank/addQuesToExam`, // 随机组卷(考试)
		examAddAddFrequency: `${host}/api/v1/exam/ques/bank/addFrequency`, // 引用次数增加
		// 面访绩效统计
		telephoneChargeTJ: `${host}/api/v1/tbPaperUnderwayController/telephoneChargeTJ`, // 绩效统计/话费统计
		queryOneSampleAccessRecordStatistics: `${host}/api/v1/tbPaperUnderwayController/queryOneSampleAccessRecordStatistics`, //查询访员df的样本拨打记录
		queryAllSampleInterviewlogStatistics: `${host}/api/v1/tbPaperUnderwayController/queryAllSampleInterviewlogStatistics`, //  查询访员df或者mf的样本访问状态
		queryAllSampleStatistics: `${host}/api/v1/tbPaperUnderwayController/queryAllSampleStatistics`, // 查询访员的df或者mf绩效
		// 绩效统计导出
		exportAllSampleStatistics: `${host}/api/v1/tbPaperUnderwayController/exportAllSampleStatistics`, //   导出访员的df或者mf绩效
		exportAllSampleInterviewlogStatistics: `${host}/api/v1/tbPaperUnderwayController/exportAllSampleInterviewlogStatistics`, // 导出访员df或者mf的样本访问状态
		exportOneSampleAccessRecordStatistics: `${host}/api/v1/tbPaperUnderwayController/exportOneSampleAccessRecordStatistics`, //   导出访问记录统计
		modifyRate: `${host}/api/v1/tbPaperUnderwayController/modifyRate`, //    设置费率
		queryRate: `${host}/api/v1/tbPaperUnderwayController/queryRate`, //   查询费率
		// 电访样本统计
		queryWJSampleStatisticsChart: `${host}/api/v1/tbPaperUnderwayController/queryWJSampleStatisticsChart`, // 样本统计 — 返回问卷的样本统计 surveyId问卷id                                      
		queryUserCount: `${host}/api/v1/tbPaperUnderwayController/queryUserCount`, //电访 - 查询本问卷的总访员个数和访员在线人数  surveyId问卷id   
		queryAllUserSampleCount: `${host}/api/v1/tbPaperUnderwayController/queryAllUserSampleCount`, // 实时统计 - 查询访员名字、在线状态、完成个数、成功率、约访和稍后个数surveyId问卷id   
		transferUserAppointmentSampleToOtherUser: `${host}/api/v1/tbPaperUnderwayController/transferUserAppointmentSampleToOtherUser`, //   电访 - 转让某个访员的全部约访样本
		resetUserLaterSample: `${host}/api/v1/tbPaperUnderwayController/resetUserLaterSample`, // 回收某个访员的全部的稍后样本
		queryFinishDetails: `${host}/api/v1/tbPaperUnderwayController/queryFinishDetails`, // 查询总完成数，完成率，访问时长，平均访问时长
		setUserLoginState: `${host}/api/v1/tbPaperUnderwayController/setUserLoginState`, // 选择一个访员注销   传userId
		// 电访配额修改
		modifyQuota: `${host}/api/v1/questionnaireNewQuota/modifyQuota`, // 大的修改
		modifyChildQuota: `${host}/api/v1/questionnaireNewQuota/modifyChildQuota`, //   修改子配额配额
		delChildQuota: `${host}/api/v1/questionnaireNewQuota/delChildQuota`, //    删除子配额配额
		querySamplValueByEnfieldName: `${host}/api/v1/questionsfieldmapping/querySamplValueByEnfieldName`, // 通过英文字段去mongo中获得该字段下有哪些值                qId 问卷id        enfieldName 英文字段
		// 样本配置 抽样导入 
		// 号段管理
		getPhoneLibPageList: `${host}/api/v1/tbDPhonelib/getPhoneLibPageList`, //   查询局号列表信息
		getPhoneLibProviceGroup: `${host}/api/v1/tbDPhonelib/getPhoneLibProviceGroup`, //  获取省份分组信息
		getPhoneLibCityGroup: `${host}/api/v1/tbDPhonelib/getPhoneLibCityGroup`, //  获取城市分组信息
		getPhoneLibAreaGroup: `${host}/api/v1/tbDPhonelib/getPhoneLibAreaGroup`, //  获取区域分组信息
		insertPhonelib: `${host}/api/v1/tbDPhonelib/insertPhonelib`, // 局号库管理 添加
		deletePhonelib: `${host}/api/v1/tbDPhonelib/deletePhonelib`, //  删除局号
		modifyPhonelib: `${host}/api/v1/tbDPhonelib/modifyPhonelib`, //  修改局号
		importPhonelib: `${host}/api/v1/tbDPhonelib/importPhonelib`, //  导入局号 
		// 抽号任务
		queryPhoneTaskList: `${host}/api/v1/tbDPhonetask/queryPhoneTaskList`, //查询用户自己的抽样记录分页
		insertPhoneTask: `${host}/api/v1/tbDPhonetask/insertPhoneTask`, //  创建抽样任务
		removePhoneTask: `${host}/api/v1/tbDPhonetask/removePhoneTask`, //   删除抽样任务
		queryPhoneTaskResultList: `${host}/api/v1/tbDPhoneresult/queryPhoneTaskResultList`, //  根据任务编号查询抽取号码结果详情
		queryPhoneTaskByID: `${host}/api/v1/tbDPhonelib/queryPhoneTaskByID`, //  根据任务编号查询抽取号码结果详情
		getPhoneLibPartList: `${host}/api/v1/tbDPhonelib/getPhoneLibPartList`, // 获取局信息
		// 抽样导入
		importPhoneTaskToSample: `${host}/api/v1/tbDPhonetask/importPhoneTaskToSample`, //  获取局列表
		// 导入级联题
		importStageQues:`${host}/api/v1/tbDPhonelib/importStageQues`, //  导入级联题
		downloadAnswerVoice:`${host}/api/v1/tbPaperUnderwayController/downloadAnswerVoice`, //  下载录音文件
		downloadAnswerPhoto:`${host}/api/v1/tbPaperUnderwayController/downloadAnswerPhoto`, //  下载图片文件
	
		// 数据报表设置
		fieldConfAddOrUpdate:`${host}/api/v1/detailsFieldConf/addOrUpdate`, //修改或添加
		fieldConfDel:`${host}/api/v1/detailsFieldConf/del`, //删除
		fieldConfDetails:`${host}/api/v1/detailsFieldConf/details`, //详情
		// 问卷题目答题表
		addExportConf:`${host}/api/v1/questions-obj/addExportConf`, //添加导出题型配置
		exportConf:`${host}/api/v1/questions-obj/exportConf`, //导出题型配置
		customDataStatistics:`${host}/api/v1/questions-obj/customDataStatistics`, //定制题目统计
		exportChoice:`${host}/api/v1/questions-obj/exportChoice`, //新导出题目统计excel
		questionList: `${host}/api/v1/questions-obj/questionList`, //查询项目所有问题
		querySampleImportState:`${host}/api/v1/questionsfieldmapping/querySampleImportState`, //查询导入进度
		deleteSampleImportRedis:`${host}/api/v1/questionsfieldmapping/deleteSampleImportRedis`,//删除信息
		samplegetPhoneLibCityGroup:`${host}/api/v1/tbDPhonelib/getPhoneLibCityGroup`,//获取城市分组信息 参数： provinces 省份名字
		samplegetPhoneLibAreaGroup:`${host}/api/v1/tbDPhonelib/getPhoneLibAreaGroup`,//获取地区分组信息 参数： provinces 省份名字，city 城市名字
		queryImportPhoneTaskState:`${host}/api/v1/tbDPhonetask/queryImportPhoneTaskState`,//	查询抽样导入进度　参数：qId　问卷id3
		deleteImportPhoneTaskRedis:`${host}/api/v1/tbDPhonetask/deleteImportPhoneTaskRedis`,//	  删除抽样导入redis 参数：qId　问卷id
		matrixInputQuestion: `${host}/api/v1/questions-obj/matrixInputQuestion`, //填空题分页
		removeScreeningCOndition: `${host}/api/v1/projectSample-obj/removeScreeningCOndition`, //
		questionnairePreview: `${host}/api/v1/questionnaire-type/preview`, //
		quoteTemp: `${host}/api/v1/questionnaire-type/quoteTemp`, //
		uploadApi: `${host}/api/v1/common/upload`, // 通用文件上传接口
		
		// sible功能
		modifyIsEnableSible: `${host}/api/v1/tbPaperUnderwayController/modifyIsEnableSible`, // 设置问卷的是否开启sible功能
		modifySibleScoringFormula: `${host}/api/v1/tbPaperUnderwayController/modifySibleScoringFormula`, // 设置问卷的sible问卷总分公式
		querySiebelFieldTable: `${host}/api/v1/questionsfieldmapping/querySiebelFieldTable`, //查询福田的字段映射表有哪些字段
		saveSiebleFieldToFieldMapping: `${host}/api/v1/questionsfieldmapping/saveSiebleFieldToFieldMapping`, // 把选择的福田字段添加进字段映射表
		queryFieldMappingNotIsSys: `${host}/api/v1/questionsfieldmapping/queryFieldMappingNotIsSys`, //查询添加的自定义字段，按照创建时间正序排序
		removeFieldMapping: `${host}/api/v1/questionsfieldmapping/removeFieldMapping`, //删除自定义字段
		modifyIsEnableSibleScoringFormula: `${host}/api/v1/tbPaperUnderwayController/modifyIsEnableSibleScoringFormula`, //设置问卷的是否开启sible

		setCopyrightConfig: `${host}/api/v1/questionnaire/setCopyrightConfig`, // 版权语设置
		
		modifyValidDays: `${host}/api/v1/tbPaperUnderwayController/modifyValidDays`, // 设置问卷有效时间

		// 问卷规则设置
		addRule: `${host}/api/v1/siebelrule/addRule`, //添加规则
		queryRule: `${host}/api/v1/siebelrule/queryRule`, //查询规则
		removeRule: `${host}/api/v1/siebelrule/removeRule`, //删除规则
		modifyRule: `${host}/api/v1/siebelrule/modifyRule`, //修改规则
		// 枚举
		addEnum: `${host}/api/v1/siebelruleenum/addEnum`, //添加枚举
		queryEnumByType: `${host}/api/v1/siebelruleenum/queryEnumByType`, //查询枚举
		removeEnumByIds: `${host}/api/v1/siebelruleenum/removeEnumByIds`, //删除枚举
		modifyEnumById: `${host}/api/v1/siebelruleenum/modifyEnumById`, //修改枚举
		
		exportWjWrod: `${host}/api/v1/tbPaperUnderwayController/exportWjWrod`, // 导出问卷的word
		exportKsWrod: `${host}/api/v1/tbPaperUnderwayController/exportKsWrod`, // 导出考试的word
		
		replaceSkipUrl: `${host}/api/v1/tbPaperUnderwayController/replaceSkipUrl`, //  替换问卷答题后跳转路径的值并返回
		synchronizationTOSiebel: `${host}/api/v1/questions/synchronizationTOSiebel`, //  替换问卷答题后跳转路径的值并返回
	
		// 角色管理
		addRole: `${host}/api/v1/sysrole/addRole`, //添加角色
		modifyRole: `${host}/api/v1/sysrole/modifyRole`, //编辑角色
		removeRole: `${host}/api/v1/sysrole/removeRole`, //删除角色
		queryRole: `${host}/api/v1/sysrole/queryRole`, //查询全部角色
		// 角色权限
		queryPermission: `${host}/api/v1/sysRolepermission/queryPermission`, //查询页面权限
		addRolePermission: `${host}/api/v1/sysRolepermission/addRolePermission`, //给角色添加权限或修改权限
		queryRolePermission: `${host}/api/v1/sysRolepermission/queryRolePermission`, //查询角色权限
		addRoleToUser: `${host}/api/v1/sysuserrole/addRoleToUser`, //给用户添加角色
		removeRoleToUser: `${host}/api/v1/sysuserrole/removeRoleToUser`, //给用户删除角色
		questionnaireDetail: `${host}/api/v1/questions/questionnaireDetail`, //
		quesBank:`${host}/api/v1/paper/ques/bank/quesList`,
		updateQues:`${host}/api/v1/exam/ques/bank/updateQuesPaper`,
		// 数据分析
		importPpt:`${host}/api/v1/ppt/importPpt`,//导出ppt
		

		// 微信分享签名（考试、问卷）
		createSignature:`${host}/api/v1/wxApi/createSignature`,

		// xml 文件解析接口
		importXml:`${host}/api/v1/questions/importXml`
	},
};
